/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Replace_AssetInputs */

const en_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace Asset`)
};

const es_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar activo`)
};

const fr_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer l'élément`)
};

const de_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset ersetzen`)
};

const ja_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットを置き換える`)
};

const zh_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替换素材`)
};

const ar_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استبدال الأصل`)
};

const id_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganti Aset`)
};

const it_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci Risorsa`)
};

const ru_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заменить ресурс`)
};

const pt_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituir Ativo`)
};

const ko_replace_asset = /** @type {(inputs: Replace_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 교체`)
};

/**
* | output |
* | --- |
* | "Replace Asset" |
*
* @param {Replace_AssetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const replace_asset = /** @type {((inputs?: Replace_AssetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Replace_AssetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_replace_asset(inputs)
	if (locale === "es") return es_replace_asset(inputs)
	if (locale === "fr") return fr_replace_asset(inputs)
	if (locale === "de") return de_replace_asset(inputs)
	if (locale === "ja") return ja_replace_asset(inputs)
	if (locale === "zh") return zh_replace_asset(inputs)
	if (locale === "ar") return ar_replace_asset(inputs)
	if (locale === "id") return id_replace_asset(inputs)
	if (locale === "it") return it_replace_asset(inputs)
	if (locale === "ru") return ru_replace_asset(inputs)
	if (locale === "pt") return pt_replace_asset(inputs)
	return ko_replace_asset(inputs)
});